import { defineReactiveModel, Persistable, belongsTo } from "vue-app-utils";
import Model from "@/models/model";
import { createSession } from "@/models/session";
import { ordinal, rating } from "openskill";
import { ordinalToScaledDisplayRating } from "@/utils/scaled-display-rating";

const Member = {
  extends: Model,
  mixins: [
    Persistable,
    belongsTo("league")
  ],
  data () {
    return {
      memberUserId: "",
      userModel: null,
      paid: false,
      startOfLeagueMu: 0,
      startOfLeagueSigma: 0
    };
  },
  created () {
    let resolveUserModel;
    this.promiseUserModel = new Promise((resolve) => {
      resolveUserModel = resolve;
    });
    this.$watch("memberUserId", (id) => {
      if (id) {
        createSession(this.$store).findUserById(id).then((user) => {
          this.userModel = user;
          resolveUserModel(user);
        });
      }
    }, { immediate: true });
  },
  computed: {
    name () {
      return this.userModel?.playerName || "";
    },
    startOfLeagueOrdinal () {
      return ordinal(rating({ mu: this.startOfLeagueMu, sigma: this.startOfLeagueSigma }));
    },
    startOfLeagueDisplayRating () {
      return ordinalToScaledDisplayRating(this.startOfLeagueOrdinal);
    }
  }
};

export default defineReactiveModel(Member);